export const SET_APPLICANT_TAGS = 'SET_APPLICANT_TAGS';

export function setApplicantTags(payload) {
  return {
    type: SET_APPLICANT_TAGS,
    payload
  };
}
